// GENERATED by scripts/build-icons.mjs from icons/chevron-left.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const ChevronLeft = createIcon('chevron-left', [
  ['path', { d: "m15 18-6-6 6-6" }],
])
